/**
 * ★ SINGLE SOURCE OF TRUTH FOR THE PRODUCT NAME & BRANDING ★
 *
 * EVERY template, page title, heading, alt text, or any string that displays
 * the product name MUST read from this object (import { APP }).
 *
 * NEVER hardcode "Padhaaii" in any .html or .ts file except THIS one.
 * Renaming the product = editing this file only.
 */
export const APP = {
  name: 'Padhaaii',
  tagline: 'Complete School ERP',
  version: '1.0.0',
  supportEmail: 'support@padhaaii.in',
  /**
   * Typing this as the "school code" on the login page routes to the PLATFORM
   * super-admin login (no tenant). Not a real school slug.
   */
  superAdminCode: 'admin',
} as const;

export type AppBranding = typeof APP;
